<template>
  <div id="app">
    <NetworkStatus />

    <!-- Ensure Loader component is correctly placed -->
    <Loader />
    <router-view/>
    <PwaInstallButton />
  </div>
</template>

<script>
import Loader from "@/components/layout/Loader";
import NetworkStatus from "@/components/layout/NetworkStatus.vue";
import PwaInstallButton from "@/components/layout/PwaInstallButton.vue";
import {Storage} from "@/Services/Storage";
import {LytningService} from "@/Services/LytningService";
import Swal from "sweetalert2";
import router from "@/router";

export default {
  components: { Loader, NetworkStatus, PwaInstallButton },
  async mounted() {
    await this.validatePCRegistration();
    await this.checkLytningSubscriptionAndLogout();
  },
  methods: {
    validatePCRegistration() {
      return this.$store.dispatch('refreshState');
    },
    async checkLytningSubscriptionAndLogout() {
      try {
        const mobileUser = await Storage.getMobileUser();
        const allStores = await Storage.getAllStores();

        if (mobileUser && allStores && allStores.length > 0 && allStores[0].mainCustomerID) {
          const hasLytningSubscription = await LytningService.checkLytningSubscription(allStores[0].mainCustomerID);

          // if (hasLytningSubscription) {
          //   const storeNames = allStores.map(s => s.StoreName || s.name || s.storeName || 'Unknown Store').join(', ');
          //   await Swal.fire({
          //     title: 'Lyt-ning Subscription Detected',
          //     icon: 'warning',
          //     html: `<p>Your account has a Lyt-ning subscription.</p><p>The following stores are on the Lyt-ning package:</p><p><strong>${storeNames}</strong></p><p>Please use the Lytning platform to access your stores.</p><p>You will now be logged out.</p>`,
          //     confirmButtonText: 'OK',
          //     confirmButtonColor: '#558B2F',
          //     allowOutsideClick: false,
          //     allowEscapeKey: false
          //   }).then(async () => {
          //     await this.$store.dispatch('clearStoreState');
          //     try {
          //       await router.push({name: 'login'});
          //     } catch (e) {}
          //   });
          //   return;
          // }
        }
      } catch (error) {
        console.error('Lyt-ning subscription check failed:', error);
      }
    }
  }
}
</script>

<style lang="scss">
@import "assets/css/styles";

.accordion-button:active {
  transform: scale(1) !important;
}
</style>
